<!-- 测试两边通信的 -->
<template>
  <div class="test-wrap">
    <div
      class="iframe-wrap"
      :style="{ top: contentTop + 'px' }"
    >
      <iframe
        id="test"
        :src="url"
        :height="height"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: '',
      height: '200px',
      userId: '',
      contentTop: 200
    };
  },
  mounted() {
    this.init();
    this.handlerIframeMessage();
  },
  methods: {
    handlerIframeMessage() {
      window.addEventListener('message', (e) => {
        console.log('监听消息: ', e.data);
        if (e.data && e.data.data && e.data.data.width !== undefined) {
          this.width = `${e.data.data.width}px`;
          this.height = `${e.data.data.height}px`;

          const clientHeight = document.documentElement.clientHeight;
          this.contentTop = clientHeight - e.data.data.height;
          console.log('contentTop', this.contentTop);
        }
        if (e.data && (e.data.data === 'confirm' || e.data.data === 'cancel')) {
          if (e.data.data === 'confirm') {
            this.userId = e.data.userId;
          }
        }
      });
    },
    init() {
      const thirdData = {
        name: '王一博',
        mobilePhone: '18680332357',
        sex: 'F'
      };

      const userId = '1234567890';
      const thirdUrl = `https://sitzengzhi.cias.cn/h5/#/applicat?data=${JSON.stringify(
        thirdData
      )}&channel=pingan_common_hospital_serve&userId=${userId}`;
      this.url = thirdUrl;
    }
  }
};
</script>

<style lang="scss" scoped>
.test-wrap {
  /* opacity: 0.5; */
  /* background: #000000; */
  position: relative;

  .iframe-wrap {
    position: absolute;
    top: 200px;
  }
}
</style>
